const BenefitCard = ({ item, index }) => {
    const { description } = item;

    return (
        <div key={description} className="benefit-card">
            <div className="gradient-number dark">
                <span>{index + 1}</span>
            </div>
            <div className="body1 opacity-80 benefit-card__text" dangerouslySetInnerHTML={{ __html: description }}>
            </div>
        </div>
    );
};

export default BenefitCard;
